import { Theme } from '@mui/material/styles';
import { DealActivityEventPriority, DealActivityLinkType, DealActivityType } from '@trnsact/trnsact-shared-types';

export const PRIORITY_CONFIG: Record<DealActivityEventPriority, { label: string; color: (theme: Theme) => string }> = {
  [DealActivityEventPriority.High]: { label: 'High', color: theme => theme.palette.error.main },
  [DealActivityEventPriority.Medium]: { label: 'Medium', color: theme => theme.palette.warning.main },
  [DealActivityEventPriority.Low]: { label: 'Low', color: theme => theme.palette.success.main },
};

export const ACTIVITY_TYPE_LABELS: Partial<Record<DealActivityType, string>> = {
  [DealActivityType.Call]: 'Call',
  [DealActivityType.Note]: 'Note',
  [DealActivityType.Sms]: 'SMS',
  [DealActivityType.Email]: 'Email',
};

export const ACTIVITY_PARENT_ROUTES: Record<DealActivityLinkType, string> = {
  [DealActivityLinkType.Vo]: '/vo',
  [DealActivityLinkType.Cs]: '/cs',
  [DealActivityLinkType.Account]: '/customers',
};
